export default __webpack_public_path__ + "static/media/Monk's Straps of the Abyss.0b204418.jpg";